import { getAppType } from "./helper";
import { getCompanyId } from "./idHelpers";

export const generateAppStepUrl = () => {
  const appType = getAppType();
  const companyId = getCompanyId();
  const baseBackendUrl = process.env.REACT_APP_WISTERIA_WOMBAT_HOST;
  return `${baseBackendUrl}/application_step/${companyId}/${appType.toLowerCase()}`;
};

export const postApplicationStepUpdate = async ({
  stepName,
  appStatus,
  completed,
  token,
}: {
  stepName: string;
  appStatus?: string;
  completed: boolean;
  token: string;
}) => {
  const requestUrl = generateAppStepUrl();

  const requestBody: { [key: string]: string | boolean } = {
    step_name: stepName,
    completed: completed,
  };

  if (appStatus) {
    requestBody.status = appStatus;
  }

  await fetch(requestUrl, {
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });

  return true;
};

interface StepType {
  step_name: string;
  completed: boolean;
}

export interface StepDataType {
  application_uuid: string;
  last_step_name: string;
  last_step_name_completed: string | null;
  current_step: number;
  total_steps: number;
  status: string;
  created_at: string;
  submission_date: string | null;
  steps: StepType[];
}
